<!--
 * @Author: M.D.
 * @Date: 2019-12-23 14:25:25
 * @LastEditors  : M.D.
 * @Description: 商品评价
 * @Remarks:
 -->
<template>
  <div class="pay-box">
    <p>微信扫一扫付款</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import wx from 'weixin-jsapi'
export default {
  props: {},
  data () {
    return {
      appid: '',
      timestamp: '',
      noncestr: '',
      signature: '',
      package: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.appid = this.$route.query.appId
    this.timestamp = this.$route.query.timeStamp
    this.package = decodeURIComponent(this.$route.query.package)
    this.noncestr = this.$route.query.nonceStr
    this.signature = this.$route.query.paySign.toUpperCase()
    this.wxConfig()
    this.wxPay()
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  watch: {},
  methods: {
    wxConfig () {
      let _this = this
      wx.config({
        'debug': false, // 这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
        'appId': _this.appid,
        'timestamp': _this.timestamp,
        'nonceStr': _this.noncestr,
        'paySign': _this.signature,
        'jsApiList': ['chooseWXPay'],
        success: function (res) {
          alert('支付成功')
        },
        fail: function (res) {
          alert('支付失败')
        },
        complete: function (res) {
          _this.wxPay()
        }
      })
    },
    wxPay () {
      let _this = this
      wx.ready(function () {
        wx.chooseWXPay({
          'appId': _this.appid,
          'nonceStr': _this.noncestr,
          'package': _this.package,
          'signType': 'MD5',
          'timestamp': _this.timestamp,
          'paySign': _this.signature,
          success: function (res) {
            alert('支付成功')
          },
          cancel: function (res) {
            alert('支付取消')
          },
          fail: function (res) {
            alert('支付失败')
          }
        })
      })
    }

  }
}
</script>

<style lang="stylus">
  .pay-box
    width 100%
    height 100%
    text-align center

    .pay-fee
      color #FF9D55
      font-size 18px
    .pay-code
      img
        display initial
</style>
